export default {
    interests (state) {
        return state.interests
    },
    getAllInterests (state) {
        return state.interestList
    },
    getUserInterests (state) {
        return state.userInterests
    }
}



// WEBPACK FOOTER //
// ./src/store/interest/getters.js